<template>
  <div id="pers-tab2-2" name="hres32e-tab2-tab2">

    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC4']['20'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic1">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['30'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numoffid" name="numoffid" 
                     v-model="detail.numoffid" 
                     maxlength="13"
                     v-validate="'max:13'"
                     data-vv-name="numoffid"
                     :has-error="errors.has('numoffid')" />
              <div class="text-error" v-show="errors.has('numoffid')">{{errors.first('numoffid')}}</div>
            </div>
          </div>     
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['60'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-datepicker  v-model="detail.dteoffid"
                                  v-validate="'required|date_format:DD/MM/YYYY'"
                                  data-vv-value-path="inputDate"
                                  name="dteoffid"
                                  :has-error="errors.has('dteoffid')" 
                                  style="margin-bottom:5px;"/>
                <div class="text-error" v-show="errors.has('dteoffid')">{{errors.first('dteoffid')}}</div>    
            </div>
          </div>
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['40'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="adrissue" name="adrissue" 
                     v-model="detail.adrissue"
                     maxlength="20"
                     v-validate="'max:20'"
                     data-vv-name="adrissue"
                     :has-error="errors.has('adrissue')" />
              <div class="text-error" v-show="errors.has('adrissue')">{{errors.first('adrissue')}}</div>
            </div>
          </div>  
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['50'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codprovi" 
                                :options="dropdowns.codprovr[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>

          <div class="data-row data-row-line"></div>  

          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['70'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numpasid" name="numpasid" 
                     v-model="detail.numpasid"
                     maxlength="20"
                     v-validate="'max:20'"
                     data-vv-name="numpasid"
                     :has-error="errors.has('numpasid')" />
              <div class="text-error" v-show="errors.has('numpasid')">{{errors.first('numpasid')}}</div>
            </div>
          </div>     
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['80'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-datepicker  v-model="detail.dtepasid"
                                  v-validate="'requiredWhenExist:numpasid|date_format:DD/MM/YYYY'"
                                  data-vv-value-path="inputDate"
                                  name="dtepasid"
                                  :has-error="errors.has('dtepasid')" 
                                  style="margin-bottom:5px;"/>
                <div class="text-error" v-show="errors.has('dtepasid')">{{errors.first('dtepasid')}}</div>  
            </div>
          </div>
         
          <div class="data-row data-row-line"></div>  
          
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['90'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numprmid" name="numprmid" 
                     v-model="detail.numprmid" 
                     maxlength="20"
                     v-validate="'max:20'"
                     data-vv-name="numprmid"
                     :has-error="errors.has('numprmid')" />
              <div class="text-error" v-show="errors.has('numprmid')">{{errors.first('numprmid')}}</div>
            </div>
          </div>     
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['100'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-datepicker  v-model="detail.dteprmst"
                                  v-validate="'requiredWhenExist:numprmid|date_format:DD/MM/YYYY'"
                                  data-vv-value-path="inputDate"
                                  name="dteprmst"
                                  :has-error="errors.has('dteprmst')" 
                                  style="margin-bottom:5px;"/>
                <div class="text-error" v-show="errors.has('dteprmst')">{{errors.first('dteprmst')}}</div>  
            </div>
          </div>
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['110'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-datepicker  v-model="detail.dteprmen"
                                  v-validate="'requiredWhenExist:numprmid|date_format:DD/MM/YYYY|after:dteprmst'"
                                  data-vv-value-path="inputDate"
                                  name="dteprmen"
                                  :has-error="errors.has('dteprmen')" 
                                  style="margin-bottom:5px;"/>
                <div class="text-error" v-show="errors.has('dteprmen')">{{errors.first('dteprmen')}}</div>  
            </div>
          </div>
          
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-right">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic2">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC4']['120'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic2">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['130'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numlicid" name="numlicid" 
                     maxlength="13"
                     v-model="detail.numlicid" 
                     v-validate="'max:13'"
                     data-vv-name="numlicid"
                     :has-error="errors.has('numlicid')" />
              <div class="text-error" v-show="errors.has('numlicid')">{{errors.first('numlicid')}}</div>
            </div>
          </div>
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['140'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-datepicker  v-model="detail.dtelicid"
                                  v-validate="'requiredWhenExist:numlicid|date_format:DD/MM/YYYY'"
                                  data-vv-value-path="inputDate"
                                  name="dtelicid"
                                  :has-error="errors.has('dtelicid')" 
                                  style="margin-bottom:5px;"/>
                <div class="text-error" v-show="errors.has('dtelicid')">{{errors.first('dtelicid')}}</div>  
            </div>
          </div>         
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic3">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC4']['150'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic3">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['160'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.stamarry" 
                                :options="dropdowns.stamarry[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC4']['170'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.stamilit" 
                                :options="dropdowns.stamilit[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
      <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hres32e-tab2-tab2',
  data () {
    return {
      subTopic1: true,
      subTopic2: true,
      subTopic3: true
    }
  },
  watch: {
    'detail.numoffid' () {
      this.$validator.validate('numoffid', this.detail.numoffid).catch(e => {})
    },
    'detail.dteoffid' () {
      this.$validator.validate('dteoffid', this.detail.dteoffid).catch(e => {})
    },
    'detail.adrissue' () {
      this.$validator.validate('adrissue', this.detail.adrissue).catch(e => {})
    },
    'detail.numpasid' () {
      this.$validator.validate('numpasid', this.detail.numpasid).catch(e => {})
    },
    'detail.dtepasid' () {
      this.$validator.validate('dtepasid', this.detail.dtepasid).catch(e => {})
    },
    'detail.numprmid' () {
      this.$validator.validate('numprmid', this.detail.numprmid).catch(e => {})
    },
    'detail.dteprmst' () {
      this.$validator.validate('dteprmst', this.detail.dteprmst).catch(e => {})
    },
    'detail.dteprmen' () {
      this.$validator.validate('dteprmen', this.detail.dteprmen).catch(e => {})
    },
    'detail.numlicid' () {
      this.$validator.validate('numlicid', this.detail.numlicid).catch(e => {})
    },
    'detail.dtelicid' () {
      this.$validator.validate('dtelicid', this.detail.dtelicid).catch(e => {})
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    toggleSubTopic3 () {
      this.subTopic3 = !this.subTopic3
    },
    saveParams () {
      return {
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq,
        n_numoffid: this.detail.numoffid,
        n_dteoffid: this.detail.dteoffid,
        n_adrissue: this.detail.adrissue,
        n_codprovi: this.detail.codprovi,
        n_numpasid: this.detail.numpasid,
        n_dtepasid: this.detail.dtepasid,
        n_numprmid: this.detail.numprmid,
        n_dteprmst: this.detail.dteprmst,
        n_dteprmen: this.detail.dteprmen,
        n_numlicid: this.detail.numlicid,
        n_dtelicid: this.detail.dtelicid,
        n_stamarry: this.detail.stamarry,
        n_stamilit: this.detail.stamilit
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postDetail2Tab2Save({ saveParams: this.saveParams(), searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'indexSelected', 'pcDisp', 'togglePage', 'toggleSubPage', 'triggerSubButton', 'labelsButton', 'dropdowns', 'postDetail2Tab2Save', 'searchIndex', 'validateStaappr' ]
}

</script>


// WEBPACK FOOTER //
// tab2_2.vue?8f016bda